import { render } from "./CVComponent.vue?vue&type=template&id=2f593b8d&scoped=true&ts=true"
import script from "./CVComponent.vue?vue&type=script&lang=ts"
export * from "./CVComponent.vue?vue&type=script&lang=ts"

import "./CVComponent.vue?vue&type=style&index=0&id=2f593b8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f593b8d"]])

export default __exports__